export default "__VITE_ASSET__DdR7sOwx__"